module.exports = __webpack_public_path__ + "media/images/resource-placeholder02-5c753dd5c072cfd397aebbc18f080c64.jpg";